export default "__VITE_ASSET__Cygq5us4__"